import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements OnInit {

  @Input() modalData: any;
  @Input() buttonText: string = 'Delete';
  @Input() buttonClass: string = 'danger-btn';
  @Input() buttonText1: string = 'Cancel';
  @Input() buttonClass1: string = 'basic-btn';
  @Input() buttonText2: string = 'Cancel';
  @Input() buttonClass2: string = 'd-none';

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.modalData.prompt = `<span>${this.modalData.prompt}</span>`;
  }

  close(data): void {
    this.activeModal.close(data);
  }

}
